import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../../utils/apolloClient';
import config from '../../../utils/config';
import { accountConstants } from '../../../constants/accountConstants'

const initialSolutionState = {
    status: null,
    isLoadingToVerifyAccount: null,
    isFailedToVerifyAccount: null,
    last4:null,
    solnId:null,
};

export const verifyBankAccount = createAsyncThunk(
    'verifyBankAccount',
    async ({ solutionId, orgId,customerRef,last4, microDeposit1, microDeposit2, token }, { rejectWithValue }) => {
        try {
            let response = await client.authorizeRequest({
                method: 'POST',
                url: `${config.serviceEndpoints.mpDpMetadataUrl}/account/verify`,
                data: {
                    solutionId,
                    orgId,
                    customerRef,
                    last4,
                    microDeposit1,
                    microDeposit2
                },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            return response;
        } catch (error) {
            if (!error.response) {
                throw error
            }
            return rejectWithValue(error.response.data)
        }
    }
);
export const verifyAccount = createSlice({
    name: 'verifyAccountSlice',
    initialState:{},
    reducers: {
        setAccountContext: (state, action) => {
            state[action.payload.solutionId] = {...initialSolutionState}
          },
        setMultiDepositsContext:(state,action) =>{
            let solutionId = action.payload.solutionId
            state[solutionId]={
                ...state[solutionId],
                solnId:action.payload.solutionId,
                last4:action.payload.last4
            }
        }
    },
    extraReducers: {
        [verifyBankAccount.fulfilled]: (state, action) => {
            let solutionId = action.meta.arg.solutionId
            state[solutionId]={
                ...state[solutionId],
                status : accountConstants.verified,
                isLoadingToVerifyAccount : false,
                isFailedToVerifyAccount : false
            }
        },
        [verifyBankAccount.pending]: (state, action) => {
            let solutionId = action.meta.arg.solutionId
            state[solutionId]={
                ...state[solutionId],
                status : null,
                isLoadingToVerifyAccount : true,
                isFailedToVerifyAccount : false
            }
        },
        [verifyBankAccount.rejected]: (state, action) => { 
           let solutionId = action.meta.arg.solutionId
           state[solutionId]={
               ...state[solutionId],
                status : null,
                isLoadingToVerifyAccount : false,
                isFailedToVerifyAccount : action.payload && action.payload.message || "Failed to verify account. please try again."
            }
        }


    }
});

export const { setAccountContext,setMultiDepositsContext } = verifyAccount.actions;

export default verifyAccount.reducer;



